import type { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import { colors, spacing } from '../../../themes/variables';

type Variant = 'default' | 'sticky-bottom';

interface IStyles {
  wrapper: (ignoreSafeArea: boolean, variant: Variant) => FelaCSS;
}

const styles: IStyles = {
  wrapper: (ignoreSafeArea: boolean, variant: Variant = 'default') => ({
    width: '100%',
    gap: spacing[4],
    padding: spacing[4],
    background: colors.white,
    zIndex: 100,
    onlyWidthMobile: {
      borderTop: `1px solid ${colors.space08}`,
    },

    ...(!ignoreSafeArea && {
      supportsSafeAreaInset: {
        paddingBottom: `calc(${spacing[4]} + env(safe-area-inset-bottom))`,
      },
    }),

    ...(variant === 'sticky-bottom' && {
      position: 'sticky',
      bottom: 0,
      marginTop: 'auto',
    }),
  }),
};

export default styles;
